import styled from "styled-components";

export const CheckboxStyles = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  .checkboxMask {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    border: 1px solid ${({ theme }) => theme.colors.primary[200]};
    border-radius: ${({ theme }) => theme.radius[4]};
    cursor: pointer;
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .checkboxMask:hover {
    background: ${({ theme }) => theme.colors.primary[100]};
    border: 1px solid ${({ theme }) => theme.colors.primary[300]};
  }

  .checked {
    background: ${({ theme }) => theme.colors.semantic.accent.default} !important;
    border: 1px solid ${({ theme }) => theme.colors.semantic.accent.default} !important;
  }

  .checkboxInput {
    width: 16px;
    height: 16px;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
  }

  .label {
    font-style: normal;
    font-weight: ${({ theme }) => theme.typography.body.b2.weight};
    font-size: ${({ theme }) => theme.typography.body.b2.size};
    line-height: ${({ theme }) => theme.typography.body.b3.lineHeight};
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    margin-left: ${({ theme }) => theme.spacing[12]};
  }
`;
